import type { CSSProperties } from '@mui/styles';

import HelveticaNeueBlack from '../assets/fonts/HelveticaNeue/HelveticaNeueLT93BlackExtended.ttf';

type TFontFace = CSSProperties['@font-face'];

export const helveticaNeueBlack: TFontFace = {
  fontFamily: 'HelveticaNeueBlack',
  fontStyle: 'normal',
  fontWeight: 900,
  src: `url(${HelveticaNeueBlack})`,
};
